module.exports = __webpack_public_path__ + "static/assets/d80d3d886e672db9f1caad23e6653f0d.png";